document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('click', function (event) {
        if (event.target.id === 'elementor-menu-cart__toggle_button') {
            const wcFragmentRefreshEvent = new Event('wc_fragment_refresh', { bubbles: true, cancelable: true })
            document.body.dispatchEvent(wcFragmentRefreshEvent)
        }
    })
})
